module.exports = __webpack_public_path__ + "static/img/introduction_banner.e5e216ab.png";